<template>
  <div id="app" class="home">
    <img
      :src="agentBuyInfo.buyImgUrl"
      v-if="agentBuyInfo.buyImgUrl"
      class="buyImg"
    />
    <h2 v-if="!agentBuyInfo.buyImgUrl" class="loadingTip">
      <span v-if="!getBuyInfoDone">加载中，请稍候</span>
      <span v-if="getBuyInfoDone"
        >若您已经购买，请点击屏幕左侧“返回键”<br />点击已付款完成激活</span
      >
    </h2>
  </div>
</template>

<script>
import qs from "query-string";

function request(option) {
  try {
    option.method = "GET";
    var xhr = new XMLHttpRequest();
    // xhr.responseType = option.responseType || "json";
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          if (option.success && typeof option.success === "function") {
            option.success(xhr.response);
          }
        } else {
          if (option.error && typeof option.error === "function") {
            option.error();
          }
        }
      }
    };
    xhr.open(option.method, option.url, true);
    xhr.send();
  } catch (e) {
    alert(e.message);
  }
}

export default {
  name: "Home",
  components: {},
  mounted() {
    const urlParsed = qs.parseUrl(window.location.href);
    const { query } = urlParsed;
    this.agent = query.agent;
    this.getAgentBuyInfo();

    this.prepareSize();

    setTimeout(this.prepareSize, 500);
  },
  methods: {
    // 思域 实际365
    async prepareSize() {
      const ele = document.getElementById("app");
      ele.style.width = `${document.documentElement.clientWidth}px`;
      ele.style.height = `${document.documentElement.clientHeight}px`;
    },
    async getAgentBuyInfo() {
      try {
        const buyInfoMeta = await new Promise((resolve, reject) => {
          request({
            url: `/vapi/proxy/buyinfo?name=${this.agent}`,
            success: function (response) {
              const res = JSON.parse(response);
              if (res && res.code === 20000) {
                resolve(res.data);
              } else {
                reject(new Error("请求出错"));
              }
            },
            error: function (err) {
              reject(err);
            },
          });
        });

        this.agentBuyInfo = JSON.parse(buyInfoMeta.value);
        this.getBuyInfoDone = true;
      } catch (e) {
        this.getBuyInfoDone = true;
        this.agentBuyInfo = {};
      }
    },
  },
  data() {
    return {
      getBuyInfoDone: false,
      agent: "",
      agentBuyInfo: {},
    };
  },
};
</script>

<style scoped src="./TeamCar.scss" lang="scss"></style>
